import Component from '@glimmer/component';
import ContactModel from 'donor-elf-web/models/contact';
import { type ContactCustomPropertyInfo } from 'donor-elf-web/services/contacts-cache';
import MergeContactsSection from 'donor-elf-web/components/add-something-modal/merge-contacts/section';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import CopyPasteButton from 'donor-elf-web/components/add-something-modal/merge-contacts/copy-paste-button';
import ContactCustomPropertyEdit from 'donor-elf-web/components/contact/details/properties/custom-property/edit-value';
import ContactCustomPropertyShow from 'donor-elf-web/components/contact/details/properties/custom-property/show';
import isPresent from 'donor-elf-web/helpers/is-present';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';

interface ComponentArgs {
  customPropertyInfo: ContactCustomPropertyInfo;
  customPropertyChangeset: any;
  contactToKeep: ContactModel;
  contactToMerge: ContactModel;
  showValidationErrors: boolean;
}

export default class AddSomethingModalMergeContactsMergeCustomPropertyComponent extends Component<ComponentArgs> {
  get isList() {
    return this.args.customPropertyInfo.t === 'l';
  }

  copyPropertyFrom = (contact: ContactModel) => {
    const value = contact.customPropertyValue(this.args.customPropertyInfo.l);
    this.args.customPropertyChangeset.set('v', value);
  }

  get contactToKeepValue() {
    return this.args.contactToKeep.customPropertyValue(this.args.customPropertyInfo.l);
  }

  get contactToMergeValue() {
    return this.args.contactToMerge.customPropertyValue(this.args.customPropertyInfo.l);
  }

  <template>
    <div ...attributes>
      <MergeContactsSection
        @header={{@customPropertyInfo.l}}
      >
        <div class='pb-1'>
          <div class='row'>
            <div class='col'>
              <FormUnderlineLabel
                @label='Value to Keep'
              >
                <ContactCustomPropertyEdit
                  @propertyInfo={{@customPropertyInfo}}
                  @changeset={{this.args.customPropertyChangeset}}
                  @userCanAddOptions={{false}}
                  @showValidationErrors={{@showValidationErrors}}
                  class='w-100'
                />
              </FormUnderlineLabel>
            </div>
            <div class='col'>
              <FormUnderlineLabel @label='Contact to Keep'>
                {{#if (isPresent this.contactToKeepValue)}}
                  <div class='d-flex'>
                    {{#unless this.isList}}
                      <div>
                        <CopyPasteButton
                          {{on 'click' (fn this.copyPropertyFrom @contactToKeep)}}
                        />
                      </div>
                    {{/unless}}
                    <div>
                      <ContactCustomPropertyShow
                        @customPropertyLabel={{@customPropertyInfo.l}}
                        @contact={{@contactToKeep}}
                      />
                    </div>
                  </div>
                {{else}}
                  <div class='text-muted font-weight-light'>---</div>
                {{/if}}
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Contact to Merge'>
                {{#if (isPresent this.contactToMergeValue)}}
                  <div class='d-flex'>
                    {{#unless this.isList}}
                      <div>
                        <CopyPasteButton
                          {{on 'click' (fn this.copyPropertyFrom @contactToMerge)}}
                        />
                      </div>
                    {{/unless}}
                    <div>
                      <ContactCustomPropertyShow
                        @customPropertyLabel={{@customPropertyInfo.l}}
                        @contact={{@contactToMerge}}
                      />
                    </div>
                  </div>
                {{else}}
                  <div class='text-muted font-weight-light'>---</div>
                {{/if}}
              </FormUnderlineLabel>
            </div>
          </div>
        </div>
      </MergeContactsSection>
    </div>
  </template>
}
